// extracted by mini-css-extract-plugin
export default {"container":"ContactsBanner_container__4hi0e","title":"ContactsBanner_title__aKJuF","mailContainer":"ContactsBanner_mailContainer__xgHVE"};